import { NavLink } from "react-router-dom";
import { Home, Store, Heart, ShoppingBag, User } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "../../lib/store";

export const MobileTabBar = () => {
  const { cartCount, wishlist } = useStore();
  const items = [
    { to: "/", label: "Home", Icon: Home },
    { to: "/shop", label: "Shop", Icon: Store },
    { to: "/wishlist", label: "Wishlist", Icon: Heart, count: wishlist.length },
    { to: "/cart", label: "Cart", Icon: ShoppingBag, count: cartCount },
  ];
  const cls = "relative flex flex-1 flex-col items-center gap-1 py-2.5 text-[10px] font-semibold uppercase tracking-[0.12em]";
  return (
    <nav data-testid="mobile-tab-bar" className="fixed inset-x-0 bottom-0 z-50 flex border-t border-plum/10 bg-cream/95 backdrop-blur-xl md:hidden pb-[env(safe-area-inset-bottom)]">
      {items.map(({ to, label, Icon, count }) => (
        <NavLink key={label} to={to} end data-testid={`tab-${label.toLowerCase()}`} className={({ isActive }) => `${cls} ${isActive ? "text-magenta" : "text-plum/75"}`}>
          <Icon className="h-5 w-5" />
          {label}
          {count > 0 && <span className="absolute right-[26%] top-1.5 grid h-4 min-w-4 place-items-center rounded-full bg-magenta px-1 text-[9px] text-white">{count}</span>}
        </NavLink>
      ))}
      <button data-testid="tab-account" onClick={() => toast("Accounts are coming soon to Luxe Dream Market")} className={`${cls} text-plum/75`}>
        <User className="h-5 w-5" />
        Account
      </button>
    </nav>
  );
};
